<button
    #triggerButton
    #origin="cdkOverlayOrigin"
    cdkOverlayOrigin
    mat-icon-button
    st-click-stop-propagation
    st-space-stop-propagation
    st-enter-stop-propagation
    [matTooltip]="tooltip()"
    [disabled]="disabled()"
    (click)="toggle()">
    <mat-icon>filter_list</mat-icon>
</button>

<ng-template
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="overlayOrigin() ?? origin"
    [cdkConnectedOverlayOpen]="open()"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayPositions]="resolvedPositions()"
    (overlayKeydown)="onEscPress($event)"
    (backdropClick)="close()"
    (detach)="close()">
    <st-section-filter
        cdkTrapFocus
        cdkTrapFocusAutoCapture="true"
        [config]="config()"
        [state]="state()"
        [disabled]="disabled()"
        (stateChange)="stateChange.emit($event)"
        (save)="save.emit()"
        (revert)="revert.emit()"
        (clear)="clear.emit()" />
</ng-template>
